// Split from the write step so callers can batch their layout reads into one pass.
export const readViewportUnits = () => ({
	rootFontSize: parseFloat(
		getComputedStyle(document.documentElement).fontSize
	),
	innerHeight: window.innerHeight,
	bodyWidth: document.body.clientWidth,
});

export const writeViewportUnits = ({
	rootFontSize,
	innerHeight,
	bodyWidth,
}) => {
	document.documentElement.style.setProperty(
		'--vh',
		`${(innerHeight * 0.01) / rootFontSize}rem`
	);

	document.documentElement.style.setProperty(
		'--vw',
		`${(bodyWidth * 0.01) / rootFontSize}rem`
	);
};

const viewportUnits = () => {
	writeViewportUnits(readViewportUnits());
};

export default viewportUnits;
